module.exports = __webpack_public_path__ + "img/photo-0096.032b5336.jpg";